<div class="dialog-container">
  <!-- Header -->
  <div class="dialog-header flex items-center justify-between pb-4">
    <h2 class="text-xl font-semibold">Kép feltöltése</h2>
    <button
      type="button"
      mat-icon-button
      (click)="onCancel()"
      class="text-dark-green"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content py-8">
    <!-- Upload Zone (no file selected) -->
    <div
      *ngIf="!uploadedFileName"
      (click)="openFileInput()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      class="hover:bg-gray-50 border-gray-300 bg-gray-50 flex min-h-[100px] cursor-pointer flex-col justify-center rounded-lg border-2 border-dashed px-3 transition-all"
      [class.border-blue-400]="isDragOver"
      [class.bg-blue-50]="isDragOver"
    >
      <div class="flex items-center gap-2">
        <mat-icon class="text-turquoise">image</mat-icon>
        <p class="text-gray-600 text-left text-sm">
          Húzd ide a fájlt vagy kattints a feltöltéshez
        </p>
      </div>
    </div>

    <!-- Selected File Display (with trash icon) -->
    <div
      *ngIf="uploadedFileName"
      class="flex items-center justify-between rounded-lg border border-customGreen-400 bg-customGreen-100 px-3 py-2"
    >
      <div
        (click)="openFileInput()"
        class="flex flex-1 cursor-pointer items-center gap-2"
      >
        <mat-icon class="text-turquoise">image</mat-icon>
        <span class="text-sm font-medium text-customGreen-500">
          {{ uploadedFileName }}
        </span>
      </div>
      <button
        type="button"
        mat-icon-button
        (click)="clearSelectedFile(); $event.stopPropagation()"
        class="text-customRed-300"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <!-- Format Information -->
    <p class="mt-3 text-xs text-dark-gray">Formátum: PNG / JPG / JPEG</p>

    <!-- Hidden File Input -->
    <input
      #fileInput
      id="car-image-file-input"
      type="file"
      accept="image/png,image/jpeg,image/jpg"
      (change)="onFileSelected($event)"
      style="display: none"
    />
  </div>

  <!-- Footer -->
  <div class="dialog-footer flex items-center justify-end gap-3 pt-4">
    <button color="primary"  mat-stroked-button (click)="onCancel()" class="mol-btn-stroked-primary h-12 w-full rounded-2xl text-base font-bold">
      Mégse
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSave()"
      [disabled]="!hasChanges"
      class="mol-btn-primary h-12 w-full rounded-2xl text-base font-bold"
    >
      Mentés
    </button>
  </div>
</div>
